import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback } from 'react';
import { fromJS, List } from 'immutable';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { segmentTrack } from 'flow/actions/segment-actions';
import { TICKET_STRINGS } from 'flow/utils/segment-utils';
import { shiftPickedMentions } from 'flow/utils/ticket-utils';
export var useMentionAutoComplete = function useMentionAutoComplete(_ref) {
  var messageContentInternal = _ref.messageContentInternal,
    setMessageContentInternal = _ref.setMessageContentInternal,
    getCaretPosition = _ref.getCaretPosition,
    setCaretPosition = _ref.setCaretPosition,
    setShowMentionPicker = _ref.setShowMentionPicker,
    sendMessage = _ref.sendMessage;
  var dispatch = useAppDispatch();
  var handleMentionAutoComplete = useCallback(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, extensionKey) {
      var mentionText, trimCharacter, caretPosition, messageText, textBeforeCaret, textAfterCaret, trimmedTextBeforeCaret, newText, mentionStart, lengthDiff;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (name) {
              _context.next = 2;
              break;
            }
            _context.next = 1;
            return sendMessage();
          case 1:
            return _context.abrupt("return");
          case 2:
            mentionText = "@".concat(name, " ");
            trimCharacter = '@';
            caretPosition = getCaretPosition();
            messageText = (messageContentInternal === null || messageContentInternal === void 0 ? void 0 : messageContentInternal.text) || ''; // Split text at caret position
            textBeforeCaret = messageText.substring(0, caretPosition);
            textAfterCaret = messageText.substring(caretPosition); // Remove the partial mention text (everything after the last @)
            trimmedTextBeforeCaret = textBeforeCaret.substring(0, textBeforeCaret.lastIndexOf(trimCharacter)); // Construct new text with completed mention
            newText = trimmedTextBeforeCaret + mentionText + textAfterCaret; // Update message content
            mentionStart = trimmedTextBeforeCaret.length;
            setMessageContentInternal(function (prev) {
              var mentionsShifted = shiftPickedMentions(prev.mentions, prev.text, newText, mentionStart + mentionText.length);
              if (!extensionKey) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  text: newText,
                  mentions: mentionsShifted
                });
              }
              var pickedMention = fromJS({
                extensionKey: extensionKey,
                name: name,
                start: mentionStart
              });
              return _objectSpread(_objectSpread({}, prev), {}, {
                text: newText,
                mentions: (mentionsShifted !== null && mentionsShifted !== void 0 ? mentionsShifted : List()).push(pickedMention)
              });
            });

            // Calculate new caret position
            lengthDiff = mentionText.length - (textBeforeCaret.length - trimmedTextBeforeCaret.length);
            setCaretPosition(caretPosition + lengthDiff);

            // Close mention picker and track the event
            setShowMentionPicker(false);
            dispatch(segmentTrack(TICKET_STRINGS.USER_MENTIONED_COLLEAGUE));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [messageContentInternal, setMessageContentInternal, getCaretPosition, setCaretPosition, setShowMentionPicker, sendMessage, dispatch]);
  return {
    handleMentionAutoComplete: handleMentionAutoComplete
  };
};